export const campusOptions = [

  "All Campus",
  "BENGALURU",
  "BHOPAL",
  "BHUBANESWAR",
  "CHENNAI",
  "DAMAN",
  "GANDHINAGAR",
  "HYDERABAD",
  "JODHPUR",
  "KANGRA",
  "KANNUR",
  "KOLKATA",
  "MUMBAI",
  "NEW DELHI",
  "PANCHKULA",
  "PATNA",
  "RAEBARELI",
  "SHILLONG",
  "SRINAGAR"
];

export const courseOptions = [

  "All Course",
  "Apparel Marketing and Management",
  "Apparel Marketing Merchandising and Management",
  "B. Des Accessory Design",
  "B. Des Fashion Communication",
  "B. Des Knitwear Design",
  "B. Des Leather Design (Footwear & Products)",
  "B. Des Textile Design",
  "B.Des in Fashion Design",
  "B.Des in Fashion Design II",
  "B.F. Tech Apparel Production",
  "Bachelor of Accessory Design (Jewellery)",
  "Bachelors Degree in Apparel Manufacturing",
  "Bachelors Degree in Apparel Manufacturing and IT",
  "Diploma in Accessory Design",
  "Diploma in Fashion Design",
  "Fashion and Information Technology",
  "Fashion Design and Information Technology",
  "Fashion Management Studies",
  "Leather Design (Garments & Products)",
  "M.Des Design Space",
  "M.F. Tech Apparel Production",
  "Master of Fashion Management",
  "PG BRIDGE PROGRAM",
  "PG Diploma in Garment Manufacturing Technology",
  "PG Diploma in Knitwear Design and Technology",
  "PG Diploma in Textile Design",
  "PG DIPLOMA LEATHER GARMENT DESIGN AND TECHNOLOGY",
  "PhD"
];
// export const batchOptions = [
//   "All Batch",
//   "1988",
//   "1989",
//   "1990",
//   "1993",
//   "1993",
//   "1994",
//   "1994",
//   "1995",
//   "1995",
//   "1996",
//   "1996",
//   "1997",
//   "1997",
//   "1998",
//   "1998",
//   "1999",
//   "1999",
//   "2000",
//   "2000",
//   "2001",
//   "2001",
//   "2002",
//   "2002",
//   "2002",
//   "2003",
//   "2003",
//   "2004",
//   "2004",
//   "2005",
//   "2005",
//   "2006",
//   "2006",
//   "2007",
//   "2007",
//   "2007",
//   "2008",
//   "2008",
//   "2008",
//   "2009",
//   "2009",
//   "2010",
//   "2010",
//   "2011",
//   "2011",
//   "2012",
//   "2012",
//   "2013",
//   "2013",
//   "2013",
//   "2014",
//   "2014",
//   "2015",
//   "2015",
//   "2016",
//   "2016",
//   "2017",
//   "2017",
//   "2017",
//   "2018",
//   "2018",
//   "2019",
//   "2019",
//   "2020",
//   "2020",
//   "2021",
//   "2021",
//   "2022",
//   "2022"
// ];

export const batchOptions = [
  "All Batch",
  ...Array.from(
    { length: new Date().getFullYear() - 1990 + 1 },
    (_, i) => (1990 + i).toString()
  )
];
